<template>
  <div class="grey-background">
    <b-container>
      <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="4">
        <b-col class="content">
          <b-icon-droplet class="h1 mb-2 color-icon"></b-icon-droplet>
          <h6 class="heading margin-bottom-extrasmall">Țesătură ușoară</h6>
          <p class="margin-bottom-null">
            Confecționate din fâș subțire permeabil, care respiră
          </p>
        </b-col>
        <b-col class="content">
          <b-icon-shield class="h1 mb-2 color-icon"></b-icon-shield>
          <h6 class="heading margin-bottom-extrasmall">Material rezistent</h6>
          <p class="margin-bottom-null">
            Potrivit pentru exterior sau interior, poate susține până la 120 de
            kg
          </p>
        </b-col>
        <b-col class="content">
          <b-icon-puzzle class="h1 mb-2 color-icon"></b-icon-puzzle>
          <h6 class="heading margin-bottom-extrasmall">
            Accesorii incluse
          </h6>
          <p class="margin-bottom-null">
            Hamac, cârlige de ancorare, două cordeline de 5 metri rezistente la frecare și
            uzură
          </p>
        </b-col>
        <b-col class="content">
          <b-icon-link45deg class="h1 mb-2 color-icon"></b-icon-link45deg>
          <h6 class="heading margin-bottom-extrasmall">Produs compact</h6>
          <p class="margin-bottom-null">
            Cu o greutate totală de 400g, se poate monta în câteva secunde
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.grey-background {
  background-color: #f6f6f6;
}

.color-icon {
  color: green;
  width: 50px;
  height: 50px;
}

.content {
  padding: 20px;
  text-align: center;
}

h6.heading {
  color: #2f2911;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0;
  text-align: center;
}

.margin-bottom-null {
  margin-bottom: 0 !important;
}

p {
  color: #6e6b66;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
  font-weight: 300;
  font-style: italic;
}
</style>
